import React from 'react';
import styled from 'styled-components';
import { Registration } from '../../../types/models/registration';
import { DateAttr } from '../../../components/date-attr';

const ProviderWrapper = styled.span``;
const UserWrapper = styled.span``;

const ListItem = styled.li`
  display: grid;
  grid-template-columns: 5em 1fr 1fr;
  grid-gap: 1em;
`;
interface RegistrationItemProps {
  registration: Registration;
}

export function RegistrationItem(props: RegistrationItemProps) {
  return (
    <ListItem>
      <DateAttr date={props.registration.signupDate} />
      <ProviderWrapper>{props.registration.serviceProviderName}</ProviderWrapper>
      <UserWrapper>{props.registration.username}</UserWrapper>
    </ListItem>
  );
}
